/**
 * Currency helpers. Phase 1 keeps the FX rates as static constants
 * (matching the legacy demo) — Phase 2 will pull live rates from
 * exchangerate.host with a daily cache.
 *
 * All `price` values in Firestore are whole USD (see types/Part.ts).
 */

export type CurrencyCode = 'USD' | 'CAD' | 'GBP' | 'EUR' | 'AUD';

export const CURRENCIES: readonly CurrencyCode[] = ['USD', 'CAD', 'GBP', 'EUR', 'AUD'];

export const FX_RATES: Record<CurrencyCode, number> = {
  USD: 1,
  CAD: 1.36,
  GBP: 0.79,
  EUR: 0.92,
  AUD: 1.51,
};

export const FX_SYMBOLS: Record<CurrencyCode, string> = {
  USD: '$',
  CAD: 'C$',
  GBP: '£',
  EUR: '€',
  AUD: 'A$',
};

export function isCurrencyCode(value: string): value is CurrencyCode {
  return (CURRENCIES as readonly string[]).includes(value);
}

/**
 * Convert a USD amount to the target currency and format it with
 * the appropriate symbol and 2 decimal places.
 */
export function fx(usd: number, currency: CurrencyCode = 'USD'): string {
  const rate = FX_RATES[currency];
  const value = usd * rate;
  return `${FX_SYMBOLS[currency]}${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
